module.exports = __webpack_public_path__ + "static/media/bonyan-logo-only.81eba14a.png";